/* eslint-disable */
import * as Yup from 'yup';
import React, { useState, useEffect, useRef } from 'react';
import {
    Container, Card, FormControl, InputLabel, Checkbox, InputAdornment, FormHelperText
} from '@material-ui/core';

import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Box, Button } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Divider from '@material-ui/core/Divider';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import TablePagination from '@mui/material/TablePagination';
import Page from '../../../Page';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _ from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles';
import services from '../Services';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import SearchNotFound from '../../../SearchNotFound';

import { makeStyles } from '@material-ui/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import Chip from '@material-ui/core/Chip';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';

var screenCode = "FCCPURCHASEPRICEVARIATIONREPORT"

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    {
        id: 'orderDate',
        numeric: false,
        disablePadding: false,
        label: 'Date',
        align: "left"
    },
    {
        id: 'skuCode',
        numeric: false,
        disablePadding: false,
        label: 'SKU Code',
        align: "left"
    },
    {
        id: 'sku',
        numeric: false,
        disablePadding: false,
        label: 'SKU',
        align: "left"
    },
    {
        id: 'factoryName',
        numeric: false,
        disablePadding: false,
        label: 'FCC',
        align: "left"
    },
    {
        id: 'realizedPrice',
        numeric: true,
        disablePadding: false,
        label: 'Buying Price(LKR)',
        align: "right"
    },
    {
        id: 'savingQty',
        numeric: true,
        disablePadding: false,
        label: 'Savings Per kg',
        align: "right"
    },

    {
        id: 'acceptedQuantity',
        numeric: true,
        disablePadding: false,
        label: 'Volume(kg)',
        align: "right"
    },
    {
        id: 'totalSaving',
        numeric: true,
        disablePadding: false,
        label: 'Saving(Rs)',
        align: "right"
    },


];
function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    //Print
    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 750
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    }
}));

export default function FCCPurchasePriceVariationReport(props) {

    const navigate = useNavigate();
    const componentRef = useRef();
    const [csvHeaders, SetCsvHeaders] = useState([]);

    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('cropForecastdate');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const onKeyDown = (e) => {
        e.preventDefault();
    };

    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'Crop Wise Availability'
    });

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const [group, setGroup] = useState([]);
    const [factory, setFactory] = useState([]);
    const [product, setProduct] = useState([]);
    const [productcatogery, setProductcatogery] = useState([]);
    const [isActive, setIsActive] = useState(true);
    const [toDate, setToDate] = useState(new Date());
    const [fromDate, setFromDate] = useState(new Date());
    const [purchasePrice, setPurchasePrice] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedCategoryOptions, setSelectedCategoryOptions] = useState([]);
    const [selectedProductOptions, setSelectedProductOptions] = useState([]);
    const [factoryTypeID, setFactoryTypeID] = useState(0);
    const [loginfactoryTypeID, setLoginFactoryID] = useState(0);

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, purchasePrice.length - page * rowsPerPage);

    const [formData, setFormData] = useState({
        groupID: 0,
        operationEntityID: 0,
        cropCategoryID: 0,
        cropID: 0,
        fromDate: new Date(fromDate).toISOString(),
        toDate: new Date(toDate).toISOString(),
        isActive: true
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const purchasePriceSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.array()
            .min(1, 'Please select at least one fresh collection center')
            .required('Please select at least one fresh collection center'),
        cropCategoryID: Yup.array()
            .min(1, 'Please select at least one product category')
            .required('Please select at least one product category'),
        cropID: Yup.array()
            .min(1, 'Please select at least one product')
            .required('Please select at least one product'),
        toDate: Yup.date().min(1).min(1, 'Please Select End date').required('End date required'),
        fromDate: Yup.date().min(1).min(1, 'Please Select From Date').required('Start From Date required'),
        toDate: Yup.date().min(1).min(1, 'Please Select To Date').required('Start To Date required')
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: '',
        operationEntity: '',
        cropCategory: '',
        crop: '',
        toDate: '',
        fromDate: ''
    });

    const [totalValues, setTotalValues] = useState({
        totalAcceptedQuantity: 0,
        totalAcceptedQuantity: 0,

    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: selectedOptions,
            cropCategoryID: selectedCategoryOptions,
            cropID: selectedProductOptions,
            fromDate: formData.fromDate,
            toDate: formData.toDate,
            isActive: formData.isActive
        },
        validationSchema: purchasePriceSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm());
        },
    });

    const isFutureDateDisabled = (date) => {
        return date > new Date();
    };

    useEffect(() => {
        getPermissions();
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'FCCPURCHASEPRICEVARIATIONREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());
        trackPromise(GetProductCategoties());

        var tokenFac = parseInt(TokenDecoder.getFactoryTypeFromToken())
        setFactoryTypeID(tokenFac);
        setLoginFactoryID(parseInt(TokenDecoder.getFactoryTypeFromToken()))
    }

    async function SubmitForm() {
        let model = {
            operationEntityID: selectedOptions.map(x => x).join(',').toString(),
            cropID: selectedProductOptions.map(x => x).join(',').toString(),
            fromDate: fromDate,
            toDate: toDate
        }

        var response = await services.GetFCCPurchasePriceVariationReportData(model);

        var newselectedOptions = []
        if (factoryTypeID == 1) {
            newselectedOptions = selectedOptions.filter(x => x !== loginfactoryTypeID)
        } else {
            newselectedOptions = selectedOptions
        }
        response.forEach((item) => {
            item.savingQty = newselectedOptions.length > 1 ? item.maxRealizedPrize - item.realizedPrice : 0;
            item.totalSaving = newselectedOptions.length > 1 ? item.acceptedQuantity * item.savingQty : 0;
        });
        let res = _.cloneDeep(response);
        res.forEach(x => {
            x.orderDate = x.orderDate.split('T')[0];
        });

        var resultOne = [];
        res.forEach(x => {

            var duplicateDate = resultOne.find(y => y.orderDate === x.orderDate && y.factoryName === x.factoryName && y.sku === x.sku);

            if (duplicateDate) {
                duplicateDate.acceptedQuantity += x.acceptedQuantity;
                duplicateDate.factoryName = x.factoryName;
                duplicateDate.realizedPrice = x.realizedPrice;
                duplicateDate.maxRealizedPrize = x.maxRealizedPrize;
                duplicateDate.operationEntityID = x.operationEntityID;
                duplicateDate.orderDate = x.orderDate;
                duplicateDate.savingQty = x.savingQty;
                duplicateDate.sku = x.sku;
                duplicateDate.skuCode = x.skuCode;
                duplicateDate.totalSaving += x.totalSaving;
            }
            else {
                resultOne.push({
                    acceptedQuantity: x.acceptedQuantity,
                    factoryName: x.factoryName,
                    maxRealizedPrize: x.maxRealizedPrize,
                    realizedPrice: x.realizedPrice,
                    operationEntityID: x.operationEntityID,
                    orderDate: x.orderDate,
                    savingQty: x.savingQty,
                    sku: x.sku,
                    skuCode: x.skuCode,
                    totalSaving: x.totalSaving,
                });
            }

        });

        setPurchasePrice(resultOne);
        createDataForExcel(resultOne);
        getSelectedDropdownValuesForReport();
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    async function clearAll() {
        if (!permissionList.isFactoryFilterEnabled) {
            setPurchasePrice([]);
            setSelectedCategoryOptions([])
            setSelectedProductOptions([])
            setToDate(new Date());
            setFromDate(new Date());
        } else {
            setSelectedOptions([])
            setPurchasePrice([]);
            setSelectedCategoryOptions([])
            setSelectedProductOptions([])
            setToDate(new Date());
            setFromDate(new Date());
        }
    }

    useEffect(() => {
        setPage(0);
        if (selectedOptions.length > 0) {
            trackPromise(GetProductCategoties());
        } else {
            trackPromise(GetAllGroups());
        }
    }, []);

    useEffect(() => {
        setPage(0);
        trackPromise(GetProductDetails());
    }, [selectedCategoryOptions]);

    useEffect(() => {
        setPage(0);
        trackPromise(GetFactoriesByGroupID());
        setSelectedCategoryOptions([])
        setSelectedProductOptions([])
    }, [formik.values.groupID]);

    useEffect(() => {
        setPage(0);
        setSelectedCategoryOptions([])
        setSelectedProductOptions([])
    }, [formik.values.operationEntityID]);
    useEffect(() => {
        setPage(0);
        setPurchasePrice([]);
        setSelectedProductOptions([])
    }, [formik.values.cropCategoryID]);

    useEffect(() => {
        setPage(0);
        setPurchasePrice([]);
    }, [formik.values.cropID]);

    useEffect(() => {
        setPage(0);
        setPurchasePrice([]);
    }, [toDate]);

    useEffect(() => {
        setPage(0);
        setPurchasePrice([]);
    }, [fromDate]);

    useEffect(() => {
        setPage(0);
        setPurchasePrice([]);
    }, [selectedOptions]);

    useEffect(() => {
        setPage(0);
        setPurchasePrice([]);
    }, [selectedCategoryOptions])

    useEffect(() => {
        setPage(0);
        setPurchasePrice([]);
    }, [selectedProductOptions])

    useEffect(() => {
        setPage(0);
        if (selectedOptions.length > 0 && selectedCategoryOptions.length > 0) {
            trackPromise(GetProductDetails())
        }
    }, [selectedCategoryOptions, selectedOptions])

    useEffect(() => {
        if (selectedOptions.length == 0) {
            setProductcatogery([])
        } else {
            trackPromise(GetProductCategoties())
        }
    }, [selectedOptions])

    useEffect(() => {
        setValues({
            ...values,
            operationEntityID: selectedOptions,
            cropCategoryID: selectedCategoryOptions,
            cropID: selectedProductOptions
        })
    }, [selectedOptions, selectedCategoryOptions, selectedProductOptions]);


    useEffect(() => {
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }, [factory]);

    useEffect(() => {
        if (purchasePrice.length != 0) {
            calculateTotalQty()
        }
    }, [purchasePrice]);

    async function GetProductCategoties() {
        var res = await services.GetProductCategoties();
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].productCategoryName, value: res[i].productCategoryID })
            }
            setProductcatogery(newOptionArray);
        }
    }

    async function GetProductDetails() {
        var res = await services.GetProductsByFactoryIDProductcatogeryID(
            selectedOptions.map(x => x).join(','),
            selectedCategoryOptions.map(x => x).join(",")
        )
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].productName, value: res[i].productID })
            }
            setProduct(newOptionArray);
        }
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function GetFactoriesByGroupID() {
        var res = await services.GetVCCFactoriesByGroupID(formik.values.groupID)
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
            }
            setFactory(newOptionArray);
        }
    }

    //Print
    async function createFile() {
        var file = await createDataForExcel(purchasePrice);
        var settings = {
            sheetName: 'FCC Purchase Price Variation',
            fileName: 'FCC Purchase Price Variation Report_' + new Date(fromDate).toISOString().split('T')[0] + '-' + new Date(toDate).toISOString().split('T')[0],
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'FCC Purchase Price Variation',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    const handleSelectChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedOptions(
                selectedOptions.length === factory.length ? [] :
                    factory.map((option) => option.value)
            );
        } else {
            setSelectedOptions(value);
        }
    };

    const handleSelectCategoryChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedCategoryOptions(
                selectedCategoryOptions.length === productcatogery.length ? [] :
                    productcatogery.map((option) => option.value)
            );
        } else {
            setSelectedCategoryOptions(value);
        }
    };

    const handleSelectProductChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedProductOptions(
                selectedProductOptions.length === product.length ? [] :
                    product.map((option) => option.value)
            );
        } else {
            setSelectedProductOptions(value);
        }
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
    };

    const handleClearCategorySelection = () => {
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
    };

    const handleClearProductSelection = () => {
        setSelectedProductOptions([]);
    };

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'Date': x.orderDate,
                    'SKU Code': x.skuCode,
                    'SKU': x.sku,
                    'FCC': x.factoryName,
                    'Buying Price (Rs)': x.realizedPrice == 0 ? '-' : parseFloat(x.realizedPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'Savings Per kg (Rs) ': x.savingQty == 0 ? '-' : parseFloat(x.savingQty).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'Volume(kg)': x.acceptedQuantity == 0 ? '-' : parseFloat(x.acceptedQuantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'Saving (Rs)': x.totalSaving == 0 ? '-' : parseFloat(x.totalSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                }
                res.push(vr);
            });

            res.push({});
            res.push({});

            var vr = {
                'Date': 'Total',
                'Volume(kg)': (totalValues.totalAcceptedQuantity == 0) || (totalValues.totalAcceptedQuantity == "-") ? '-' : parseFloat(totalValues.totalAcceptedQuantity).toFixed(2),
                'Saving (Rs)': (totalValues.totalTotalSaving == "-") || (totalValues.totalTotalSaving == 0) ? '-' : parseFloat(totalValues.totalTotalSaving).toFixed(2),
            }
            res.push(vr);

            res.push({});
            res.push({});

        }
        return res;
    }

    function getSelectedDropdownValuesForReport() {
        let groups = group.find(x => x.groupID == formik.values.groupID)
        const facName = [];
        selectedOptions.forEach(x => {
            const fildered = factory.find(y => x === y.value).label
            facName.push(fildered)
        });

        const categoryName = [];
        selectedCategoryOptions.forEach(x => {
            const filterCategory = productcatogery.find(y => x === y.value).label
            categoryName.push(filterCategory);
        })

        const productName = [];
        selectedProductOptions.forEach(x => {
            const filterProduct = product.find(y => x === y.value).label
            productName.push(filterProduct);
        })
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups.groupName,
            operationEntity: facName.map(x => x).join(','),
            cropCategory: categoryName.map(x => x).join(','),
            crop: productName.map(x => x).join(','),
            fromDate: new Date(fromDate).toISOString().split('T')[0],
            toDate: new Date(toDate).toISOString().split('T')[0]
        });
    }

    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = factory.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderCategorySelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = productcatogery.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = productcatogery.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = productcatogery.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderProductSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = product.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = product.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = product.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };
    function calculateTotalQty() {
        const totalAcceptedQuantity = purchasePrice.reduce((accumulator, current) => accumulator + current.acceptedQuantity, 0);
        const totalTotalSaving = purchasePrice.reduce((accumulator, current) => accumulator + current.totalSaving, 0);
        setTotalValues({
            ...totalValues,
            totalAcceptedQuantity: totalAcceptedQuantity,
            totalTotalSaving: totalTotalSaving,
        })

    };


    return (
        <>
            <LoadingComponent />
            <Page title="FCC Purchase Price Variation Report |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/FCCPurchasePriceVariationReport"}
                        btname="Add"
                        pageName="FCC Purchase Price Variation Report"
                        leftButtonHidden={true}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {group.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>

                                    <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                        <InputLabel id="multi-select-label">Fresh Collection Center </InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedOptions}
                                            onChange={handleSelectChange}
                                            label="Fresh Collection Center "
                                            disabled={!permissionList.isFactoryFilterEnabled}
                                            renderValue={(selected) => renderSelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={""}>
                                                <Checkbox checked={selectedOptions.length === factory.length} color="primary" />
                                                All Fresh Collection Center
                                            </MenuItem>
                                            {factory.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.operationEntityID && errors.operationEntityID && (
                                            <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                        )}
                                        {selectedOptions.length > 0 && (
                                            <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                {!permissionList.isFactoryFilterEnabled ? null :
                                                    <ClearIcon />}
                                            </IconButton>
                                        )}
                                    </FormControl>

                                    <FormControl fullWidth error={Boolean(touched.cropCategoryID && errors.cropCategoryID)}>
                                        <InputLabel id="multi-select-label">Product Category * </InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedCategoryOptions}
                                            onChange={handleSelectCategoryChange}
                                            label="Product Category "
                                            renderValue={(selected) => renderCategorySelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={""}>
                                                <Checkbox checked={selectedCategoryOptions.length === productcatogery.length} color="primary" />
                                                All Product Category
                                            </MenuItem>
                                            {productcatogery.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedCategoryOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.cropCategoryID && errors.cropCategoryID && (
                                            <FormHelperText>{errors.cropCategoryID}</FormHelperText>
                                        )}
                                        {selectedCategoryOptions.length > 0 && (
                                            <IconButton onClick={handleClearCategorySelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                    </FormControl>

                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} align='left'>
                                    <FormControl fullWidth error={Boolean(touched.cropID && errors.cropID)}>
                                        <InputLabel id="multi-select-label">Product * </InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedProductOptions}
                                            onChange={handleSelectProductChange}
                                            label="Product Category "
                                            renderValue={(selected) => renderProductSelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={""}>
                                                <Checkbox checked={selectedProductOptions.length === product.length} color="primary" />
                                                All Products
                                            </MenuItem>
                                            {product.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedProductOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.cropID && errors.cropID && (
                                            <FormHelperText>{errors.cropID}</FormHelperText>
                                        )}
                                        {selectedProductOptions.length > 0 && (
                                            <IconButton onClick={handleClearProductSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                    </FormControl>

                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="From *"
                                            value={fromDate}
                                            onChange={(newValue) => {
                                                setFromDate(newValue);
                                            }}
                                            shouldDisableDate={isFutureDateDisabled} 
                                            renderInput={(params) => (<TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('fromDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.fromDate && errors.fromDate)}
                                                helperText={touched.fromDate && errors.fromDate}
                                                {...params} />)}
                                            inputProps={{ readOnly: true, maxDate: new Date() }}
                                        />

                                    </LocalizationProvider>

                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="To *"
                                            value={toDate}
                                            onChange={(newValue) => {
                                                setToDate(newValue);
                                            }}
                                            shouldDisableDate={isFutureDateDisabled} 
                                            renderInput={(params) => (<TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('toDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.toDate && errors.toDate)}
                                                helperText={touched.toDate && errors.toDate}
                                                {...params} />)}
                                            inputProps={{ readOnly: true, maxDate: new Date() }} 
                                        />
                                    </LocalizationProvider>
                                    <div>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                color='error'
                                                onClick={() => clearAll()}
                                            > Clear</Button>
                                            <Button
                                                type="submit"
                                                color='secondary'
                                                variant="outlined"
                                            >Search</Button>
                                        </Stack>
                                    </div>
                                </Stack>
                            </Stack>

                            <br />
                            <>
                                {purchasePrice.length != 0 ? (
                                    <>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <Card style={{ justifycontent: 'center', width: '100rem' }}>
                                                <Paper className={classes.paper}>
                                                    <TableContainer>
                                                        <Table
                                                            className={classes.table}
                                                            aria-labelledby="tableTitle"
                                                            aria-label="enhanced table"
                                                        >
                                                            <EnhancedTableHead
                                                                classes={classes}
                                                                order={order}
                                                                orderBy={orderBy}
                                                                onRequestSort={handleRequestSort}
                                                                rowCount={purchasePrice.length}
                                                            />
                                                            <TableBody>
                                                                {stableSort(purchasePrice, getComparator(order, orderBy))
                                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                    .map((row, index) => {
                                                                        const labelId = `enhanced-table-checkbox-${index}`;

                                                                        return (
                                                                            <TableRow>
                                                                                <TableCell >
                                                                                    {new Date(row.orderDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', minimumIntegerDigits: 2 })}
                                                                                </TableCell>
                                                                                <TableCell>{row.skuCode}</TableCell>
                                                                                <TableCell >{row.sku}</TableCell>
                                                                                <TableCell >{row.factoryName}</TableCell>
                                                                                <TableCell align='right'>{row.realizedPrice == 0 ? "-" : parseFloat(row.realizedPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                                <TableCell align='right'>{row.savingQty == 0 ? "-" : parseFloat(row.savingQty).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                                <TableCell align='right'>{row.acceptedQuantity == 0 ? "-" : row.acceptedQuantity.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                                <TableCell align='right'>{row.totalSaving == 0 ? "-" : parseFloat(row.totalSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>

                                                                            </TableRow>
                                                                        );
                                                                    })}
                                                            </TableBody>
                                                            <TableRow>
                                                                <TableCell align="center" colSpan={6} style={{ fontWeight: "bold" }}>Total</TableCell>
                                                                <TableCell align="right" style={{ fontWeight: "bold" }}>
                                                                    {(totalValues.totalAcceptedQuantity === 0 || totalValues.totalAcceptedQuantity === "-")
                                                                        ? '-'
                                                                        : parseFloat(totalValues.totalAcceptedQuantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                </TableCell>

                                                                <TableCell align="right" style={{ fontWeight: "bold" }}>
                                                                    {(totalValues.totalTotalSaving === "-" || totalValues.totalTotalSaving === 0)
                                                                        ? '-'
                                                                        : parseFloat(totalValues.totalTotalSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                </TableCell>

                                                            </TableRow>
                                                        </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        rowsPerPageOptions={[5, 10, 25]}
                                                        component="div"
                                                        count={purchasePrice.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onPageChange={handleChangePage}
                                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                                    />
                                                </Paper>
                                            </Card>
                                        </Stack>
                                    </>
                                ) : <SearchNotFound searchQuery="FCC Purchase Price Variation Report" />}</>
                        </Form>
                    </FormikProvider>
                    {purchasePrice.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"FCC Purchase Price Variation Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    purchasePrice={purchasePrice}
                                    searchData={selectedSearchValues}
                                    totalValues={totalValues}

                                />
                            </div>
                        </Box> : null}

                </Container>
            </Page>
        </>
    );
}